export default __webpack_public_path__ + "static/media/rapid.cf829190.png";